import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Checkbox as MuiCheckbox,
    CheckboxProps as MuiCheckboxProps,
    FormControlLabel,
} from '@material-ui/core';

type CheckboxProps = MuiCheckboxProps & {
    label: string,
};

Checkbox.defaultProps = {

};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {

    },
}));

function Checkbox(props: CheckboxProps): React.ReactElement {
    const {
        label,
        onChange,
        checked,
        ...checkoutProps
    } = props;
    const classes = useStyle();

    return (
        <FormControlLabel
            label={label}
            control={(
                <MuiCheckbox color="primary" checked={checked} onChange={onChange} {...checkoutProps} />
            )}
        />
    );
}

export { Checkbox };
